import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateArchiveStatus = createSelector(
  [(store: RootState) => store.documentCreate.createArchiveStatus],
  (status) => status
);
